import { render } from "./AROrders.vue?vue&type=template&id=0245f5c7"
import script from "./AROrders.vue?vue&type=script&lang=js"
export * from "./AROrders.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__